import * as React from "react";
import { FormControlProps } from "../interfaces/FormControlProps";

import { Slug } from '@fnv-core/utils';
import { LabelAndPopover } from './components/label-and-popover';
import { PropertyHelpers } from '../helpers/PropertyHelpers';
import { FormLabelHelpers } from "./helpers/FormLabelHelpers";
import { FormFieldStateHelpers } from "./helpers/FormFieldStateHelpers";
import { RadioState } from './Radio';

class Radiostyled extends React.Component<FormControlProps, RadioState> {
  constructor(props: FormControlProps) {
    super(props);
    this.state = {
        dataSourceCounter: 0,
        timer: undefined,
        hasFocus: false
    };    
  }

  onInputFocus = (event) => {                
    this.setState({hasFocus : true});
  }

  onInputBlur = (event) => {
      if (event.persist) {
          event.persist();
      }
      this.setState({hasFocus : false}, () => {
          this.props.field.onBlur(event);
      });
  }

  render() {
    
    return <div className={"form-group form__radio-rectangle-group" + this.props.visibilityClass + ' ' + Slug.fromString(this.props.formFieldDefinition.name) + '-radio-styled-form-group'}>
      <LabelAndPopover 
            className="form__radio-rectangle-group-label"
            fieldId={PropertyHelpers.getFieldID(this.props)} 
            label={FormLabelHelpers.getFieldLabel(this)}
            explanation={this.props.formFieldDefinition.explanation}
            hasPopover={this.props.formFieldDefinition.hasPopover}                    
        ></LabelAndPopover>
    {this.props.formFieldDefinition.options.map((option : string, index : number) => {
      return <div 
          key={this.props.formFieldDefinition.name + "_" + this.props.formFieldDefinition.valueoptions[index]} 
          className="form__radio-rectangle form__radio-rectangle-inline">
        <input           
          className={this.props.form.touched[this.props.formFieldDefinition.name] &&
          this.props.form.errors[this.props.formFieldDefinition.name] ? "is-invalid form__radio-rectangle-input" : "form__radio-rectangle-input"} 
          type="radio" 
          ref={this.props.formFieldDefinition.name + index}
          id={this.props.formFieldDefinition.name + "_" + this.props.formFieldDefinition.valueoptions[index]} 
          onFocus={this.onInputFocus}
          onBlur={this.onInputBlur}
          checked={this.props.field.value == this.props.formFieldDefinition.valueoptions[index]}
          onChange={event => {
            /*if (this.props.formFieldDefinition.clearFields !== undefined) {
              this.props.formFieldDefinition.clearFields.map((fieldName : string) => {                                        
                this.props.formikBag.setFieldValue(fieldName, "");
              });                                      
            }
            */
            FormFieldStateHelpers.clearMarkedFields(this);

            let value : any = event.target.value;
                
            // workaround voor kentico/api value mismatch
            // value kan ook iets anders bevatten dan true/false (bijvoorbeeld Ja/Nee, Man/Vrouw etc)
            if (value === "true") {
                value = true;
            }
            if (value === "false") {
                value = false;
            }

            this.props.formikBag.setFieldTouched(
              this.props.formFieldDefinition.name,
              true,
              false
            );
            this.props.formikBag.setFieldValue(this.props.formFieldDefinition.name, value, true).then(() => {
              this.props.field.onChange(event);
              const error = this.props.formController.validateField(this.props.formFieldDefinition, this.props.formikBag);
              this.props.formikBag.setFieldError(this.props.formFieldDefinition.name, error);

              if (this.props.formFieldDefinition.isDependentField) {                    
                this.props.formController.setState({[this.props.formFieldDefinition.name]: this.props.formFieldDefinition.valueoptions[index]});
              } 
            })
          }} 
          
          name={this.props.formFieldDefinition.name} 
           
          value={this.props.formFieldDefinition.valueoptions[index]} />
        
        <label 
          tabIndex={0}           
          id={"label_" + this.props.formFieldDefinition.name + "_" + this.props.formFieldDefinition.valueoptions[index]} 
          htmlFor={this.props.formFieldDefinition.name + "_" + this.props.formFieldDefinition.valueoptions[index]}  
            className={"form__radio-rectangle-label " + (this.props.formFieldDefinition.valueoptions[index] == this.props.field.value ? "form__radio-rectangle-label--selected" : "")}>{option}</label>
      </div>;
    })}
    <div className="form__radio-rectangle-error">
    {!this.state.hasFocus && 
      this.props.form.touched[this.props.formFieldDefinition.name] && 
      this.props.form.errors[this.props.formFieldDefinition.name] ? <div className="form__invalid-feedback">
        {this.props.form.errors[this.props.formFieldDefinition.name]}</div> : null}
    </div>
  </div>;
  }
}

export { Radiostyled };